<template>
  <v-app-bar
    id="core-toolbar"
    app
  >
    <v-dialog
      v-model="logOutDialog"
      persistent
      width="300"
    >
      <v-card
        color="tertiary"
        dark
      >
        <v-card-text>
          Déconnexion
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-layout>
      <v-flex>
        <div class="v-toolbar-title">
          <v-toolbar-title
            class="tertiary--text font-weight-light"
          >
            <v-btn
              v-if="$route.name !== 'home' && $route.name !== 'user-login'"
              class="default v-btn--simple"
              dark
              icon
              @click.stop="onClickBtn"
            >
              <v-icon>mdi-view-list</v-icon>
            </v-btn>
          </v-toolbar-title>
        </div>
      </v-flex>
    </v-layout>

    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
            >
              <v-icon
                color="tertiary"
                left
              >
                mdi-account
              </v-icon>
              <span class=" hidden-xs-only">
                {{ userDisplayName }}
              </span>
              <v-icon
                color="tertiary"
                right
              >
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item @click="logout">
                <v-list-item-action>
                  <v-icon
                    color="tertiary"
                    left
                  >
                    mdi-lock-outline
                  </v-icon>
                </v-list-item-action>
                <v-list-item-title>Me déconnecter</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>

import { mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      logOutDialog: false
    }
  },
  computed: {
    ...mapState('app', ['drawer']),
    ...mapState('user', { userDisplayName: 'displayName' })
  },
  methods: {
    ...mapMutations('app', ['setDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    logout () {
      this.logOutDialog = true
      this.$auth.signOut().catch((error) => {
        console.error(error)
        this.logOutDialog = false
      })
    }
  }
}
</script>

<style>
    #core-toolbar a {
        text-decoration: none;
    }

    #core-toolbar .v-toolbar__content {
        margin-left: 0 !important;
    }

    #core-toolbar .v-toolbar__content {
        -webkit-transition: margin-left 0.25s; /* Safari */
        transition: margin-left 0.25s;
    }
</style>
